<section *ngIf="templatePage === 'CartPageTemplate'">
  <app-standard-cart></app-standard-cart>
</section>
<section *ngIf="templatePage === 'CheckoutPageTemplate'">
  <app-standard-cart-checkout></app-standard-cart-checkout>
</section>
